import Head from './head'
import WorksNavigation from './works-navigation'

export { Head, WorksNavigation }



// WEBPACK FOOTER //
// ./src/scenes/works/index.js